import { render, staticRenderFns } from "./Bemor.vue?vue&type=template&id=92914354&scoped=true"
import script from "./Bemor.vue?vue&type=script&lang=js"
export * from "./Bemor.vue?vue&type=script&lang=js"
import style0 from "./Bemor.vue?vue&type=style&index=0&id=92914354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92914354",
  null
  
)

export default component.exports